import trainingRouteGuard from './trainingRouteGuard';

export default trainingRouteGuard;
